import Box from "@mui/material/Box";
import React from "react";
import RouteBreadcrumbs from "../components/shared/RouteBreadcrumbs";
import { Col, Container, Row } from "react-bootstrap";
import { User } from "../components/shared/interfaces/User";
import { InfoBanner } from "../components/shared/Infobanner";
import { useUserData } from "../components/usersManagement/useUserData";
import { UserList } from "../components/usersManagement/UserList";
import { UserDetailModal } from "../components/usersManagement/UserDetailModal";
import { CreateUserModal } from "../components/usersManagement/CreateUserModal";
import { LoadingGraphic } from "../components/shared/LoadingGraphic/LoadingGraphic";

export function UsersManagement() {
  const [showUserDetailModal, setShowUserDetailModal] = React.useState<boolean>(false);
  const [showCreateUserModal, setShowCreateUserModal] = React.useState<boolean>(false);
  const [selectedUser, setSelectedUser] = React.useState<User | undefined>(undefined);
  const { users, isError, errorMessage: error, refetch, isLoading } = useUserData();

  function handleAddUserClick() {
    setShowCreateUserModal(true);
  }

  function handleUserDetailClick(user: User) {
    setSelectedUser(user);
    setShowUserDetailModal(true);
  }

  function handleUserDetailClose() {
    setSelectedUser(undefined);
    setShowUserDetailModal(false);
  }

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col className="pb-3">
            <Box>
              <RouteBreadcrumbs />
            </Box>
          </Col>
        </Row>
        <Row>
          <Col className="pb-3">
            <Row className="h-100 mh-100">
              <Col xs={12} className="h-100 mh-100">
                {isLoading && (
                  <div style={{ height: "100px" }}>
                    <LoadingGraphic />
                  </div>
                )}
                <InfoBanner message={error} show={isError} />
                {users && (
                  <UserList
                    userList={users}
                    onAddUserClick={handleAddUserClick}
                    onUserDetailClick={handleUserDetailClick}
                    loading={isLoading}
                    onDataRefreshClick={refetch}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <UserDetailModal show={showUserDetailModal} onClose={handleUserDetailClose} user={selectedUser} />
      <CreateUserModal show={showCreateUserModal} onClose={() => setShowCreateUserModal(false)} />
    </React.Fragment>
  );
}
